import * as tslib_1 from "tslib";
import React from 'react';
import styled, { withTheme } from '../styles';
import InputWrapper from '../TextInput/InputWrapper';
var ContentWrapper = styled(InputWrapper)(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  align-self: flex-start;\n  ", ";\n"], ["\n  align-self: flex-start;\n  ",
    ";\n"])), function (props) {
    return props.focused &&
        !props.readOnly &&
        "background: " + (props.theme.palette.type === 'light'
            ? 'rgba(0, 0, 0, 0.05)'
            : 'rgba(255, 255, 255, 0.05)');
});
var SelectWrapper = /** @class */ (function (_super) {
    tslib_1.__extends(SelectWrapper, _super);
    function SelectWrapper(props) {
        var _this = _super.call(this, props) || this;
        _this.handleBlur = function (event) {
            if (_this.props.readOnly) {
                return;
            }
            _this.setState({
                focused: false,
            });
            if (_this.props.onBlur) {
                _this.props.onBlur(event);
            }
        };
        _this.handleFocus = function (event) {
            if (_this.props.readOnly) {
                return;
            }
            _this.setState({
                focused: true,
            });
            if (_this.props.onFocus) {
                _this.props.onFocus(event);
            }
        };
        _this.state = { focused: false };
        return _this;
    }
    SelectWrapper.prototype.render = function () {
        var icon = React.cloneElement(this.props.icon, {
            style: {
                position: 'absolute',
                right: 0,
                top: 4,
                color: this.props.syncIconColor
                    ? this.props.theme.palette.text.secondary
                    : 'currentColor',
                pointerEvents: this.props.iconTouchable ? 'all' : 'none',
            },
        });
        return (React.createElement(ContentWrapper, tslib_1.__assign({ focused: this.state.focused, readOnly: this.props.readOnly }, this.props, { onFocus: this.handleFocus, onBlur: this.handleBlur, innerRef: this.props.innerRef }),
            this.props.children,
            !this.props.readOnly && icon));
    };
    return SelectWrapper;
}(React.PureComponent));
export default withTheme(SelectWrapper);
var templateObject_1;
//# sourceMappingURL=SelectWrapper.js.map